import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    paisId: 0,
    pais: null,
    paisNombre: null,
    nombre: '',
    inactivo: false,
    rowVersion: null,
    
    provinciaDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, provinciaId) {
        state.id = provinciaId;
        state.paisId = 0;
        state.pais = null;
        state.paisNombre = null;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_PROVINCIA'(state, provincia) {
        state.paisId = (provincia.pais) ? provincia.pais.id : 0;
        state.pais = provincia.pais;
        state.paisNombre = (provincia.pais) ? provincia.pais.nombre.trim() : null;
        state.nombre = provincia.nombre.toUpperCase().trim();
        state.inactivo = provincia.inactivo;
        state.rowVersion = provincia.rowVersion;
    },
    'SET_PAIS'(state, pais) {
        state.pais = pais;
        state.paisId = pais ? pais.id : 0;
        state.paisNombre = pais ? pais.nombre.trim() : null;
    },

    'INICIALIZAR_DATOS' (state) {
        state.provinciaDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.provinciaDatos = params.provinciaDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, provinciaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', provinciaId);

            if (provinciaId != 0) {
                apiAxios.get('provincias/' + provinciaId + '/abm' ) 
                    .then(res => {
                        commit('SET_PROVINCIA', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let provincia = {
                paisId: parseInt(state.paisId),
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo
            }

            let url = 'provincias';
            if (state.id != 0) {
                url += '/' + state.id;
                provincia.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, provincia)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setPais: ({commit}, pais) => {
        commit('SET_PAIS', pais);
    },

    getDatos ( { commit }, provinciaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (provinciaId != 0) {
                apiAxios.get('provincias/' + provinciaId ) 
                .then(res => {
                    let provinciaDatos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'pais', 'campo': 'Pais', 'valor': res.data.pais, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                        { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo? 'Si' : 'No', 'formato': '' },
                    ];
                    
                    let params = {
                        provinciaDatos 
                    }
                    commit('SET_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}